import React from "react";
import { ClientReportType } from "../../../../types/ClientReportType";
import { ReportHistoryContextProps } from "../types";
import { useGetReportQuery } from "../../../../services/clientreports"
import { useClientReportControls } from "../../../../hooks/useClientReportControls";


const ReportHistoryContext = React.createContext<ReportHistoryContextProps>({
    error: null,
    isAllowedToAssignAuthor: false,
    isAllowedToChangeReportCategories: false,
    isAllowedToChangeReportFeedback: false,
    isAllowedToChangeReportType: false,
    isAllowedToChangeReportFeedbackResponse: false,
    isLoading: false,
    isReportEditable: false,
    report: null
});

export const useReportHistory = () => React.useContext(ReportHistoryContext);

export const ReportHistoryProvider = ({ 
    children,
    masterAccountId,
    reportId
} : Readonly<{ children: JSX.Element, masterAccountId: string, reportId: string }>) => {
    const { data, error, isLoading } = useGetReportQuery({ masterAccountId, reportId });
    const controls = useClientReportControls(!data ? null : data as ClientReportType);

    return (
        <ReportHistoryContext.Provider value={{ 
            ...controls,
            error,
            isLoading,
            report: !data ? null : data as ClientReportType
        }}>
            {children}
        </ReportHistoryContext.Provider>
    );
};